import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { HeaderComponent } from './Shared/header/header.component';
import { FooterComponent } from './Shared/footer/footer.component';
import { HomeComponent } from './Components/home/home.component';
import { FeaturesComponent } from './Components/features/features.component';
import { ExamplesComponent } from './Components/examples/examples.component';
import { PricingComponent } from './Components/pricing/pricing.component';
import { EnterpriseComponent } from './Components/enterprise/enterprise.component';
import { wordpluginComponent } from './Components/word-plugin/word-plugin.component';
import { TrinkaCloudComponent } from './Components/trinka-cloud/trinka-cloud.component';
import { AboutUsComponent } from './Components/about-us/about-us.component';
import { ContactUsComponent } from './Components/contact-us/contact-us.component';
import { WorkWithUsComponent } from './Components/work-with-us/work-with-us.component';
import { PrivacyPolicyComponent } from './Components/privacy-policy/privacy-policy.component';
import { TermServicesComponent } from './Components/term-services/term-services.component';
import { PageNotFoundComponent } from './Components/page-not-found/page-not-found.component';
import { GcEditorComponent } from './Components/gc-editor/gc-editor.component';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './models/material-components.service';
import { HttpClientModule } from '@angular/common/http';
import { CKEditorModule } from 'ngx-ckeditor';
import { ToastrModule } from 'ngx-toastr';
import { MaterialModuleList } from './material-module';
import { NgtUniversalModule } from '@ng-toolkit/universal';
import { AppComponent } from './app.component';
import { TransferHttpCacheModule } from '@nguniversal/common';
import { FAQComponent } from './Components/faq/faq.component';
import { TrinkaVsGrammarlyComponent } from './Components/trinka-vs-grammarly/TrinkaVsGrammarlyComponent';
import { TrinkaVsGingerComponent } from './Components/trinka-vs-ginger/trinka-vs-ginger.component';
import { TrinkaVsLanguagetoolComponent } from './Components/trinka-vs-languagetool/trinka-vs-languagetool.component';
import { TrinkaVsWritefullComponent } from './Components/trinka-vs-writefull/trinka-vs-writefull.component';

import { LifeSciencesMedicineAndPharmaComponent } from './Components/enterprise/life-sciences-medicine-and-pharma/life-sciences-medicine-and-pharma.component';
import { LanguageServicesPublishingAndMediaComponent } from './Components/enterprise/language-services-publishing-and-media/language-services-publishing-and-media.component';
import { AcademicInstitutionsComponent } from './Components/enterprise/academic-institutions/academic-institutions.component';
import { K12AndElearningComponent } from './Components/enterprise/k12-and-elearning/k12-and-elearning.component';
import { TechnologyPlatformsComponent } from './Components/enterprise/technology-platforms/technology-platforms.component';
import { ConsistencyChecksComponent } from './Components/features/consistency-checks/consistency-checks.component';
import { PersonalDictionaryComponent } from './Components/features/personal-dictionary/personal-dictionary.component';
import { CreditsComponent } from './Components/features/credits/credits.component';
import { PublicationCheckComponent } from './Components/publication-check/publication-check.component';
import { AutoEditComponent } from './Components/auto-edit/auto-edit.component';
import { PlagiarismCheckerComponent } from './Components/features/plagiarism-checker/plagiarism-checker.component';
import { PunctuationCheckerComponent } from './Components/punctuation-checker/punctuation-checker.component';
import { SpellCheckerComponent } from './Components/spell-checker/spell-checker.component';
import { SentenceCheckerComponent } from './Components/sentence-checker/sentence-checker.component';
import { APIComponent } from './Components/enterprise/api/api.component';
import { OnlineParaphraserComponent } from './Components/features/online-paraphraser/online-paraphraser.component';
import { LatexGrammarCheckerComponent } from './Components/features/latex-grammar-checker/latex-grammar-checker.component';
import { AiDetectorToolComponent } from './Components/ai-detector-tool/ai-detector-tool.component';
import { AiContentFeedbackModalComponent } from './Components/ai-content-feedback-modal/ai-content-feedback-modal.component';
import { DetectionLimitExhaustModalComponent } from './Components/detection-limit-exhaust-modal/detection-limit-exhaust-modal.component';
import { ParapharsingToolComponent } from './Components/parapharsing-tool/parapharsing-tool.component';
import { FeedbackModalComponent } from './Components/feedback-modal/feedback-modal.component';
import { EnglishGrammarCheckerComponent } from './Components/english-grammar-checker/english-grammar-checker.component';
import { MultilingualEditorMarketingModule } from '@crimson-mohit/multilingual-editor-marketing';
import { SpanishGrammarCheckerComponent } from './Components/spanish-grammar-checker/spanish-grammar-checker.component';
import { SogangUniversityComponent } from './Components/sogang-university/sogang-university.component';
import { YonseiUniversityComponent } from './Components/university/yonsei-university/yonsei-university.component';
import { StepByStepVideosComponent } from './Components/university/step-by-step-videos/step-by-step-videos.component';
import { YeungnamUniversityComponent } from './Components/university/yeungnam-university/yeungnam-university.component';
import { KonkukUniversityComponent } from './Components/university/konkuk-university/konkuk-university.component';
import { EnterpriseModalComponent } from './Components/enterprise/enterprise-modal/enterprise-modal.component';
import { DocumarkComponent } from './Components/features/documark/documark.component';


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    FeaturesComponent,
    ExamplesComponent,
    PricingComponent,
    EnterpriseComponent,
    wordpluginComponent,
    TrinkaCloudComponent,
    AboutUsComponent,
    ContactUsComponent,
    WorkWithUsComponent,
    PrivacyPolicyComponent,
    TermServicesComponent,
    PageNotFoundComponent,
    GcEditorComponent,
    FAQComponent,
    TrinkaVsGrammarlyComponent,
    TrinkaVsGingerComponent,
    TrinkaVsLanguagetoolComponent,
    TrinkaVsWritefullComponent,
    LifeSciencesMedicineAndPharmaComponent,
    LanguageServicesPublishingAndMediaComponent,
    AcademicInstitutionsComponent,
    K12AndElearningComponent,
    TechnologyPlatformsComponent,
    ConsistencyChecksComponent,
    PersonalDictionaryComponent,
    CreditsComponent,
    PublicationCheckComponent,
    AutoEditComponent,
    PlagiarismCheckerComponent,
    PunctuationCheckerComponent,
    SpellCheckerComponent,
    SentenceCheckerComponent,
    APIComponent,
    OnlineParaphraserComponent,
    LatexGrammarCheckerComponent,
    AiDetectorToolComponent,
    AiContentFeedbackModalComponent,
    DetectionLimitExhaustModalComponent,
    ParapharsingToolComponent,
    FeedbackModalComponent,
    EnglishGrammarCheckerComponent,
    SpanishGrammarCheckerComponent,
    SogangUniversityComponent,
    YonseiUniversityComponent,
    StepByStepVideosComponent,
    YeungnamUniversityComponent,
    KonkukUniversityComponent,
    EnterpriseModalComponent,
    DocumarkComponent
  ],
  imports: [
    MultilingualEditorMarketingModule,
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    AppRoutingModule,
    CKEditorModule,
    MaterialModule,
    MaterialModuleList,
    AppRoutingModule,
    HttpClientModule,
    NgtUniversalModule,
    ToastrModule.forRoot(),
    TransferHttpCacheModule,
    CommonModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
  ],
  providers: [],
  bootstrap: [AppComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class AppModule { }
